import React, { useEffect } from 'react';
import axios from 'axios';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@/components/theme-provider';
import { Toaster } from '@/components/ui/sonner';
import Login from '@/pages/Login';
import AuthCallback from '@/pages/AuthCallback';
import Dashboard from '@/pages/Dashboard';
import About from '@/pages/About';
import Modules from '@/pages/Modules';
import ModuleDetail from '@/pages/ModuleDetail';
import AITools from '@/pages/AITools';
import ToolDetail from '@/pages/ToolDetail';
import Profile from '@/pages/Profile';
import Admin from '@/pages/Admin';
import ModuleManager from '@/pages/ModuleManager';
import Frameworks from '@/pages/Frameworks';
import FrameworkDetail from '@/pages/FrameworkDetail';
import AIPlan from '@/pages/AIPlan';
import PlanoAIFirst from '@/pages/PlanoAIFirst';
import ProtectedRoute from '@/components/ProtectedRoute';
import PendingApproval from '@/pages/PendingApproval';
import AIAssistant from '@/components/AIAssistant';
import './App.css';

function AppRouter() {
  const location = useLocation();
  const isLoginPage = location.pathname === '/';

  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/pending-approval" element={<PendingApproval />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/about" element={<ProtectedRoute><About /></ProtectedRoute>} />
        <Route path="/modules" element={<ProtectedRoute><Modules /></ProtectedRoute>} />
        <Route path="/modules/:moduleId" element={<ProtectedRoute><ModuleDetail /></ProtectedRoute>} />
        <Route path="/ai-tools" element={<ProtectedRoute><AITools /></ProtectedRoute>} />
        <Route path="/ai-tools/:toolId" element={<ProtectedRoute><ToolDetail /></ProtectedRoute>} />
        <Route path="/frameworks" element={<ProtectedRoute><Frameworks /></ProtectedRoute>} />
        <Route path="/frameworks/:frameworkId" element={<ProtectedRoute><FrameworkDetail /></ProtectedRoute>} />
        <Route path="/ai-plan" element={<ProtectedRoute><AIPlan /></ProtectedRoute>} />
        <Route path="/plano-ai-first" element={<ProtectedRoute><PlanoAIFirst /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
        <Route path="/admin/modules" element={<ProtectedRoute><ModuleManager /></ProtectedRoute>} />
      </Routes>
      {/* AI Assistant - aparece em todas as páginas exceto login */}
      {!isLoginPage && <AIAssistant />}
    </>
  );
}

function App() {
  const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
  }, []);

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <ThemeProvider defaultTheme="light" storageKey="aift-theme">
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster />
      </ThemeProvider>
    </GoogleOAuthProvider>
  );
}

export default App;